import { AgeGroup } from '../data/teams';
import { PayPalHostedButton } from './PayPalHostedButton';
import './RegistrationBreakdown.css';

// PayPal hosted button IDs for adult 15s dues, keyed by team slug.
const DUES_BUTTON_IDS: Record<string, string> = {
  womens: '24Y2SLPARD4NJ',
  mens: 'J3LLHSM49Y99G',
};

type Props = {
  ageGroup: AgeGroup;
  teamSlug: string;
};

export function RegistrationBreakdown({ ageGroup, teamSlug }: Props) {
  if (ageGroup === 'youth') {
    return (
      <div className="registration-breakdown">
        <h3>Youth &amp; High School Registration</h3>
        <p>
          Register the player to Silicon Valley Rugby Football Club using{' '}
          <a
            href="https://auth.rugbyxplorer.com.au/login?clientId=portal&codeChallenge=&redirectPath=/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rugby Xplorer
          </a>
          .
        </p>
        <p>
          Sign the player up as a member of Silicon Valley Rugby using{' '}
          <a href="https://registration.teamsnap.com/form/44660" target="_blank" rel="noopener noreferrer">
            TeamSnap
          </a>
          .
        </p>

        <h4>Fees and Dues</h4>
        <p>TBA</p>

        <p>
          Players born on or after Sep 1, 2015 should register for Flag Rugby. Players born between Sep
          1, 2011 and Aug 31, 2015 should register for Youth Rugby. For older players enrolled in 8th
          grade in 2025-2026, contact us at siliconvalleyrugby@gmail.com.
        </p>

        <h4>Steps for Rugby Xplorer</h4>
        <ol>
          <li>
            Log In or Create a Rugby Xplorer account.
            <br />
            If creating a new RX account, create an account for yourself, the parent.
            <br />
            THEN create a profile for each player you want to register.
          </li>
          <li>Click Register on the left sidebar, then Find a Club in the main window.</li>
          <li>
            Select the player to be registered (not yourself - unless you're registering as a Coach, Match
            Official, or Admin)
            <br />
            -or-
            <br />
            click Link a New Person and create a profile for the new player.
          </li>
          <li>
            Search for "Silicon Valley Rugby". Select "Silicon Valley Rugby YOUTH &amp; HS" (not "SENIOR
            CLUB").
          </li>
          <li>
            Select Role = "Player"; Type = "Flag Rugby" for U8, "Youth" for U10, U12, or MS, and "High
            School" for HS; Duration = "Season".
          </li>
          <li>
            Fill in the personal information questions, affirm the waivers, and pay for your national and
            state-level fees.
          </li>
        </ol>

        <h4>TeamSnap Registration and Dues for the 2025-2026 rugby year</h4>
        <ol>
          <li>
            Log In or Create a TeamSnap account:{' '}
            <a href="https://registration.teamsnap.com/form/44660" target="_blank" rel="noopener noreferrer">
              https://registration.teamsnap.com/form/44660
            </a>
            <br />
            If creating an account, create a profile for yourself, the parent, and follow Step 2 to add
            Youth/HS player(s).
          </li>
          <li>
            Select the Youth or HS person you want to register to play, or click "+Add a household member"
            to add a player to your household; if adding a household member, skip the Email field: we
            don't need youth player's email addresses, and you should avoid adding the parent's email
            address in that field.
          </li>
          <li>
            Select a registration option that suits your needs (players eligible for U12 should generally
            pick U12 rather than MS).
          </li>
          <li>
            Fill in the personal information questions (including USA Rugby ID#), affirm the waivers, and
            pay Silicon Valley Rugby membership dues.
          </li>
        </ol>

        <p>Welcome to Silicon Valley Rugby! Join us on Mondays and Thursdays for training.</p>
        <p>
          We will invite you to join a TeamSnap team by email. You'll be prompted to log in to TeamSnap or
          create a new household profile. Location information appears in the TeamSnap calendar.
        </p>
      </div>
    );
  }

  return (
    <div className="registration-breakdown">
      <h3>Men's and Women's Registration</h3>
      <p>
        Adult Registration will be handled through{' '}
        <a href="https://xplorer.rugby/" target="_blank" rel="noopener noreferrer">
          Rugby Xplorer
        </a>
        .
      </p>
      <ol>
        <li>Log In or Create an Account.</li>
        <li>Click Register and Find a Club.</li>
        <li>Search for "Silicon Valley Rugby". Select SENIOR CLUB.</li>
        <li>Select Role "Player". Type "Senior Club". Duration "Season".</li>
        <li>Fill in the personal information questions and pay for your registration.</li>
        <li>Once all of this is complete, you should get a receipt, and you are ready to play Rugby with Silicon Valley!</li>
      </ol>

      <h4>Fees and Dues</h4>
      <p>
        Dues are paid via PayPal.
      </p>
      {DUES_BUTTON_IDS[teamSlug] && (
        <div className="registration-paypal">
          <PayPalHostedButton hostedButtonId={DUES_BUTTON_IDS[teamSlug]} />
        </div>
      )}
    </div>
  );
}
